import { createFileRoute, redirect } from "@tanstack/react-router";
import { hasSession, serverAuth } from "@/data/auth";
import { FreelancerPortalPage } from "@/features/freelancerportal/FreelancerPortalPage";

export const Route = createFileRoute("/freelancer/")({
  // server mode: a signed-out visitor goes to sign in instead of an empty page (X16-S203)
  beforeLoad: async () => {
    if (!serverAuth || (await hasSession()) !== false) return;
    throw redirect({ to: "/sign-in", search: {} });
  },
  component: FreelancerPortalPage,
});
